import Header from "./Header";
import Hero from "./Hero";
import Products from "./Products";
import Features from "./Features";
import About from "./About";
import Footer from "./Footer";
import { Layout } from "antd";
function Home() {
  return (
    <>
      <Layout>
        <Header />
        <main>
          <Hero />
          <About />
          <Products />
          <Features />
        </main>
        <Footer />
      </Layout>
    </>
  );
}

export default Home;
